import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import AdditionalInformation from './additional_information'
import { Boolean, TextInput } from '../ui'

export default class EditorPostSkills extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'post_livestreaming',
                'post_live_multicam_editing',
                'post_basic_color_correction',
                'post_basic_color_correction_software',
                'post_basic_sound_mixing',
                'post_basic_sound_mixing_software',
                'post_dcp_export',
                'post_dcp_export_software',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let basicColorCorrectionSoftware = null
        let basicSoundMixingSoftware = null
        let dcpExportSoftware = null

        if (getProperty(this.props.data, 'post_basic_color_correction', false) === true) {
            basicColorCorrectionSoftware = (
                <TextInput
                    error={ errors.post_basic_color_correction_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_basic_color_correction_software"
                    placeholder="What software do you use?"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_basic_color_correction_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_basic_sound_mixing', false) === true) {
            basicSoundMixingSoftware = (
                <TextInput
                    error={ errors.post_basic_sound_mixing_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_basic_sound_mixing_software"
                    placeholder="What software do you use?"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_basic_sound_mixing_software') }
                />
            )
        }

        if (getProperty(this.props.data, 'post_dcp_export', false) === true) {
            dcpExportSoftware = (
                <TextInput
                    error={ errors.post_dcp_export_software }
                    handleBlur={ this._sendPatchRequest }
                    name="post_dcp_export_software"
                    placeholder="What software do you use?"
                    updateValue={ this.props.updateValue }
                    value={ getProperty(this.props.data, 'post_dcp_export_software') }
                />
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Post Skills
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <p>Are you experienced with:</p>

                        <Boolean
                            error={ errors.post_livestreaming }
                            label="Livestreaming?"
                            name="post_livestreaming"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_livestreaming') }
                        />
                        <Boolean
                            error={ errors.post_live_multicam_editing }
                            label="Multicam editing?"
                            name="post_live_multicam_editing"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_live_multicam_editing') }
                        />
                        <Boolean
                            error={ errors.post_basic_color_correction }
                            label="Basic color correction?"
                            name="post_basic_color_correction"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_basic_color_correction') }
                        />
                        { basicColorCorrectionSoftware }
                        <Boolean
                            error={ errors.post_basic_sound_mixing }
                            label="Basic sound mixing?"
                            name="post_basic_sound_mixing"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_basic_sound_mixing') }
                        />
                        { basicSoundMixingSoftware }
                        <Boolean
                            error={ errors.post_dcp_export }
                            label="DCP exports?"
                            name="post_dcp_export"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'post_dcp_export') }
                        />
                        { dcpExportSoftware }

                        <AdditionalInformation
                            { ...this.props }
                            label="Additional post skills"
                            wrapped={ false }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/editor_post_skills.js